import "./AdUnit.css";

import { useEffect, useRef } from "react";

interface AdUnitProps {
  slotId: string;
  adUnitPath: string;
  sizes: [number, number][];
}

declare global {
  interface Window {
    googletag: {
      cmd: Array<() => void>;
      defineSlot: (
        path: string,
        sizes: [number, number][],
        divId: string
      ) => { addService: (service: unknown) => unknown } | null;
      pubads: () => {
        enableSingleRequest: () => void;
        setTargeting: (key: string, values: string[]) => ReturnType<Window["googletag"]["pubads"]>;
      };
      enableServices: () => void;
      display: (divId: string) => void;
      destroySlots: (slots: unknown[]) => void;
    };
  }
}

export function AdUnit({ slotId, adUnitPath, sizes }: AdUnitProps) {
  const slotRef = useRef<unknown>(null);

  useEffect(() => {
    window.googletag.cmd.push(() => {
      const slot = window.googletag
        .defineSlot(adUnitPath, sizes, slotId)
        ?.addService(window.googletag.pubads());

      if (slot) {
        slotRef.current = slot;
      }

      window.googletag.enableServices();
      window.googletag.display(slotId);
    });

    return () => {
      window.googletag.cmd.push(() => {
        if (slotRef.current) {
          window.googletag.destroySlots([slotRef.current]);
          slotRef.current = null;
        }
      });
    };
  }, [slotId, adUnitPath, sizes]);

  return (
    <div className="ad-unit-wrapper">
      <div id={slotId} className="ad-unit-slot" />
    </div>
  );
}
